module.exports = __webpack_public_path__ + "img/logo_black.44e88e36.svg";